import {Component, Inject, OnInit} from '@angular/core';
import {DialogConfigBase} from '../dialog-config-base';
import {DialogConfigInterface} from '../dialog-config.interface';
import {MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material';
import {OfferRecalculationDialogData} from '../offer-recalculation-dialog/offer-recalculation-dialog.component';
import {DialogComponentInterface} from '../dialog-component.interface';

@Component({
  selector: 'app-offer-modification-dialog',
  templateUrl: './offer-modification-dialog.component.html',
  styleUrls: ['./offer-modification-dialog.component.scss']
})
export class OfferModificationDialogComponent implements OnInit, DialogComponentInterface {

  private readonly translationsContainer = 'OFFER_MODIFICATION_DIALOG_COMPONENT';

  static getConfigBuilder(): OfferModificationDialogConfig {
    return new OfferModificationDialogConfig();
  }

  get imageSrc(): string {
    return 'assets/images/premium-discount-image.png';
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  getTranslationKey(key: string, subContainer?: string): string {
    if (subContainer) {
      return `${this.translationsContainer}.${subContainer}.${key}`;
    }
    return `${this.translationsContainer}.${key}`;
  }

}

export class OfferModificationDialogConfig extends DialogConfigBase implements DialogConfigInterface {
  private config: MatDialogConfig = {
    panelClass: 'app-dialog',
    disableClose: true
  };

  constructor() {
    super();
  }

  buildConfiguration(data: any): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}
